import { render, staticRenderFns } from "./ProjectDetailForm.vue?vue&type=template&id=bceb91c8&scoped=true&lang=pug&"
import script from "./ProjectDetailForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetailForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetailForm.vue?vue&type=style&index=0&id=bceb91c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bceb91c8",
  null
  
)

export default component.exports